import { authenticatedFetch } from "../utils/api";
import { API_HOST } from "../utils/constants";

export const estimateGenerationCost = (payload) => authenticatedFetch(
  `${API_HOST}/api/project-cost/estimate`,
  {
    method: "POST",
    body: JSON.stringify(payload || {}),
    timeout: 30_000,
  },
);
